import p5 from "p5";
import vertSrc from "./shader.vert?raw";
import fragSrc from "./shader.frag?raw";

// "Gravitas One" Webフォントのスタイルシートを動的に追加する関数
function ensureGravitasOneStylesheet() {
  const id = "gf-gravitas-one";
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=Gravitas+One&display=swap";
  document.head.appendChild(link);
}

export class DistortApp {
  private p?: any;
  private container: HTMLElement | null = null;
  private shaderProgram?: any;
  private textGraphic?: any;

  // 状態値
  private distortion = 1.0;
  private targetDistortion = 1.0;

  // ★変更: クリック用変数をホバー用に変更
  private hoverStrength = 0.0;
  private targetHoverStrength = 0.0;
  private isHovering = false; // マウスがCanvas上にあるかを管理

  private fontReady = false;

  initialize(): void {
    this.container = document.getElementById("p5-container");
    if (!this.container) throw new Error("#p5-container が見つかりません");

    ensureGravitasOneStylesheet();

    const sketch = (p: any) => {
      p.setup = () => {
        const canvas = p.createCanvas(p.windowWidth, p.windowHeight, p.WEBGL);
        canvas.parent(this.container!);
        p.pixelDensity(1);
        p.noStroke();
        p.rectMode(p.CORNER);

        // ★変更: マウスイベントリスナーをCanvasに直接設定
        canvas.mouseOver(() => (this.isHovering = true));
        canvas.mouseOut(() => (this.isHovering = false));

        this.shaderProgram = p.createShader(vertSrc, fragSrc);

        this.textGraphic = p.createGraphics(p.width, p.height);
        this.textGraphic.pixelDensity(1);
        this.redrawTextTexture(p);

        if ((document as any).fonts && (document as any).fonts.load) {
          (document as any).fonts
            .load('150px "Gravitas One"')
            .then(() => {
              this.fontReady = true;
              this.redrawTextTexture(p);
            })
            .catch((err: any) => {
              console.error("Font could not be loaded: ", err);
            });
        }
      };

      p.draw = () => {
        p.background(255);

        // ★変更: ホバー状態に応じて目標値を設定
        if (this.isHovering) {
          this.targetHoverStrength = 1.0;
        } else {
          this.targetHoverStrength = 0.0;
        }
        this.hoverStrength = p.lerp(this.hoverStrength, this.targetHoverStrength, 0.1);
        this.distortion = p.lerp(this.distortion, this.targetDistortion, 0.05);

        if (!this.shaderProgram) return;
        p.shader(this.shaderProgram);

        this.shaderProgram.setUniform("uTexture", this.textGraphic);
        this.shaderProgram.setUniform("uDistortion", this.distortion);
        this.shaderProgram.setUniform("uTime", p.millis() / 1000);
        this.shaderProgram.setUniform("uResolution", [p.width, p.height]);

        // ★変更: ホバー用のデータをシェーダーに送る
        this.shaderProgram.setUniform("uHoverStrength", this.hoverStrength);
        const hoverU = p.mouseX / p.width + 0.5;
        const hoverV = p.mouseY / p.height + 0.5;
        this.shaderProgram.setUniform("uHoverPosition", [hoverU, hoverV]);

        p.rect(-p.width / 2, -p.height / 2, p.width, p.height);
      };

      // ★変更: mouseClickedは不要なので削除

      p.mouseWheel = (event: WheelEvent) => {
        this.targetDistortion -= (event as any).deltaY * 0.002;
        this.targetDistortion = Math.max(0, Math.min(1, this.targetDistortion));
      };

      p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight);
        this.textGraphic = p.createGraphics(p.width, p.height);
        this.textGraphic.pixelDensity(1);
        this.redrawTextTexture(p);
      };
    };

    this.p = new p5(sketch);
  }

  destroy(): void {
    if (this.p) {
      this.p.remove();
      this.p = undefined;
    }
  }

  private redrawTextTexture(p: any): void {
    if (!this.textGraphic) return;
    const g = this.textGraphic as any;
    g.clear();
    g.background(0, 0);
    g.fill("#35FFEE");
    g.noStroke();
    g.textAlign(p.CENTER, p.CENTER);
    const base = Math.max(8, Math.min(p.width, p.height) * 0.18);
    g.textSize(base);
    g.textFont(this.fontReady ? "Gravitas One" : "Helvetica");
    g.text("DISTORT", p.width / 2, p.height / 2);
  }
}
